import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface Props {
  open: boolean;
  onConfirm: (name: string) => void;
  onClose: () => void;
}

export default function NewFolderDialog({ open, onConfirm, onClose }: Props) {
  const { t } = useTranslation();
  const [name, setName] = useState('');

  const handleConfirm = () => {
    const trimmed = name.trim();
    if (trimmed) { onConfirm(trimmed); setName(''); }
  };

  const handleClose = () => { setName(''); onClose(); };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="xs" fullWidth>
      <DialogTitle>{t('myDrive.newFolder', '新增資料夾')}</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus fullWidth size="small" sx={{ mt: 1 }}
          label={t('myDrive.newFolderPlaceholder', '資料夾名稱')}
          value={name}
          onChange={e => setName(e.target.value)}
          onKeyDown={e => e.key === 'Enter' && handleConfirm()}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>{t('common.cancel', '取消')}</Button>
        <Button variant="contained" onClick={handleConfirm} disabled={!name.trim()}>
          {t('common.confirm', '確認')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
